<template>
  <div id="portifolio_list" class="landing_portfolio">
    <div class="columns is-mobile landing_portfolio_header border_b_2">
      <div
        class="column tal_l fat landing_portfolio_title"
        style="font-size: 1rem"
      >
        <p>{{ $tc("msg.component") }}</p>
      </div>
      <!-- <div class="column tal_c fat" >
        <p>{{ $t("msg.perc_portfolio") }}</p>
      </div> -->
      <div
        class="column tal_r fat landing_portfolio_title"
        style="font-size: 1rem"
      >
        <p>{{ $t("msg.change") }} (24h)</p>
      </div>
      <div
        class="column tal_c m_hidden fat landing_portfolio_title"
        style="font-size: 1rem"
      >
        <!-- <p>{{ $t("msg.price_graph") }} (7d)</p> -->
        <p>7d Graph</p>
      </div>
      <div
        class="column tal_r fat landing_portfolio_title"
        style="font-size: 1rem"
      >
        <p>{{ $t("msg.price") }} | USDT</p>
      </div>
    </div>

    <div
      class="
        is-mobile
        landing_portfolio_body
        custom_flex_block
        border_b_1
        m_text_sm
      "
      style="padding: 0 !important"
      v-for="(coin, index) in assetList"
      :key="index"
      v-if="coin.assignedOverallWeight > 0"
    >
      <div class="column landing_portfolio_item" style="padding: 0">
        <div class="custom_flex_block">
          <div class="block_1">
            <div
              class="landing_portfolio_icon background_"
              :class="'background_' + coin.currency.symbol"
            ></div>
          </div>
          <p class="dis_inb is-one-quarter" v-if="!isMobile">
            <span style="font-size: 1.2rem">{{
              coin.currency.name == "TrueUSD" ? "USDT" : coin.currency.name
            }}</span>
          </p>

          <p class="dis_inb is-one-quarter" v-else>
            <span style="font-size: 1.2rem">{{
              coin.currency.name == "TrueUSD" ? "USDT" : coin.currency.name
            }}</span>
          </p>
        </div>
      </div>
      <div class="column tal_c landing_portfolio_item">
        <div>
          <p
            v-if="coin.currency.symbol !== 'OTC'"
            :class="{
              percent_positive:
                getPercentChangeBySymbol(coin.currency.symbol) >= 0,
              percent_negative:
                getPercentChangeBySymbol(coin.currency.symbol) < 0,
            }"
          >
            <span
              v-if="getPercentChangeBySymbol(coin.currency.symbol)"
              style="font-size: 1.2rem"
              >{{ getPercentChangeBySymbol(coin.currency.symbol) }}%</span
            >
          </p>
        </div>
      </div>
      <div class="column p0 tal_c val_m m5_t m_hidden">
        <div class="column p0">
          <div
            v-if="coin.currency.symbol !== 'OTC'"
            class="custom_flex_block justify_content_between"
          >
            <div>
              <chart-line-mini :coin="coin.currency.symbol"></chart-line-mini>
            </div>
          </div>
          <div v-else>
            <div style="height: 100px"></div>
          </div>
        </div>
      </div>
      <div class="column is-one-fifth tal_r landing_portfolio_item">
        <div>
          <p style="font-size: 1.2rem">
            {{ currencyFormat(getPriceBySymb(coin.currency.symbol)) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChartLineMini from "../../public/charts_component/ChartLineMini";
import { mapGetters } from "vuex";
export default {
  props: ["assetList"],
  created() {
    this.orderArray();
    this.getPriceBySymb();
    this.getAllPricesPercent();
    this.checkIfMobile();
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    percentChange: [],
    pair: "USDT",
    isMobile: false,
  }),
  components: {
    ChartLineMini,
  },
  methods: {
    currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    getPercentChangeBySymbol(symb) {
      if (this.percentChange) {
        if (symb) {
          let coinPercent = this.percentChange.filter((percent) => {
            return percent.symbol == symb;
          });
          if (coinPercent[0]) {
            if (coinPercent[0]["24h"]) {
              return coinPercent[0]["24h"].toFixed(2);
            }
          }
        }
      }
    },

    async getAllPricesPercent() {
      let symb = "";

      for (let i in this.assetList) {
        if (this.assetList[i].currency.symbol != "OTC") {
          symb += this.assetList[i].currency.symbol + ",";
        }
      }

      symb = symb.replace(/,\s*$/, "");

      let params = {
        pair: "USDT",
        symbols: symb,
      };

      let resp = await this.$store.dispatch("getPricePercentChange", params);
      this.percentChange = resp.data;
    },

    orderArray() {
      this.assetList.sort(function (a, b) {
        return a.assignedOverallWeight > b.assignedOverallWeight
          ? -1
          : a.assignedOverallWeight < b.assignedOverallWeight
          ? 1
          : 0;
      });
    },

    getPriceBySymb(coinSymb) {
      for (let i in this.currencies) {
        if (this.currencies[i].symbol == coinSymb) {
          return this.currencies[i].value;
        }
      }
    },
    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {
    ...mapGetters(["currencies"]),
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/private/landing/LandingPortfolioList.vue